import * as types from './constants';

// Get Code Random
export const getCodeRandomRequest = data => (
  { type: types.GET_CODE_RANDOM_REQUEST, payload: data }
);

export const getCodeRandomDone = data => (
  { type: types.GET_CODE_RANDOM_DONE, payload: data }
);

export const getCodeRandomFailed = errors => (
  { type: types.GET_CODE_RANDOM_FAILED, payload: errors }
);